import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckSquare, FolderOpen, Wallet, Package, Clock, Receipt, ChevronRight, User } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

const ITEMS = [
  { to: "/salarie/taches", icon: CheckSquare, label: "Mes tâches", desc: "To-do personnelle et pro", color: "#f7c935", badge: "tasks" },
  { to: "/salarie/bulletins", icon: Wallet, label: "Mes bulletins", desc: "Bulletins de paie (PDF)", color: "#22c55e" },
  { to: "/salarie/documents", icon: FolderOpen, label: "Mes documents", desc: "Contrats, attestations, RH", color: "#38bdf8" },
  { to: "/salarie/pointages", icon: Clock, label: "Pointages", desc: "Heures et présence", color: "#06b6d4", perm: "time_tracking.view" },
  { to: "/salarie/depenses", icon: Receipt, label: "Notes de frais", desc: "Dépenses à rembourser", color: "#10b981" },
  { to: "/salarie/equipement", icon: Package, label: "Mon équipement", desc: "Matériel attribué", color: "#a855f7" },
];

export default function SalarieEspacePage() {
  const { user, axiosAuth } = useAuth();
  const [summary, setSummary] = useState(null);
  const perms = user?.module_permissions || {};

  useEffect(() => {
    axiosAuth().get("/personal/summary").then((r) => setSummary(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const badges = { tasks: summary?.tasks_todo ?? summary?.tasks?.todo ?? summary?.pending_tasks ?? 0 };
  const visible = ITEMS.filter((i) => !i.perm || perms[i.perm] || ["admin", "superadmin", "tenant_admin"].includes(user?.role));
  return (
    <div className="p-4 sm:p-8" data-testid="salarie-espace">
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-[#f7c935]/15 border border-[#f7c935]/30 flex items-center justify-center text-[#f7c935] font-black text-lg">{(user?.name || "?")[0]?.toUpperCase()}</div>
          <div>
            <h1 className="text-2xl font-black leading-tight">{user?.name}</h1>
            <div className="text-xs text-slate-400 flex items-center gap-1"><User className="w-3 h-3" /> {user?.poste || user?.email}</div>
          </div>
        </div>
        <div className="mt-6 space-y-2">
          {visible.map((i) => (
            <Link key={i.to} to={i.to} className="flex items-center gap-3 rounded-2xl border border-white/10 bg-[#14101c] p-4 hover:border-[#f7c935]/50 transition-colors" data-testid={`salarie-espace-${i.to.split("/").pop()}`}>
              <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: `${i.color}20`, color: i.color }}><i.icon className="w-5 h-5" /></div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-bold">{i.label}</div>
                <div className="text-[11px] text-slate-400">{i.desc}</div>
              </div>
              {i.badge && badges[i.badge] > 0 && <span className="text-[10px] font-black bg-[#f7c935] text-[#0b0811] rounded-full px-1.5 py-0.5">{badges[i.badge]}</span>}
              <ChevronRight className="w-4 h-4 text-slate-500" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
